module.exports = __webpack_public_path__ + "assets/media/purple-arrow-2.ff3828bb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookWoohooStep/BotWoohoo/purple-arrow-2.svg
// module id = 3132
// module chunks = 0